import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitEnquiry = (payload) => axios.post(`${API}/contact`, payload);

export const CONTACT = {
  address: "439 Elizabeth Ave, Kippa-Ring QLD 4021",
  phone: "0450 405 757",
  phoneHref: "tel:0450405757",
  email: "hello@codingin.store",
  emailHref: "mailto:sellcukozturk@gmail.com",
  hours: "Monday – Sunday · 11:00 AM – 5:00 PM",
};

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "products", label: "Products" },
  { id: "contact", label: "Contact" },
];

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const HERO_SLIDES = [
  {
    url: "https://images.unsplash.com/photo-1773514294087-b93f864866a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NzAzNTl8MHwxfHNlYXJjaHwzfHxkb25lciUyMGtlYmFiJTIwc3BpdCUyMHRha2Vhd2F5JTIwY291bnRlcnxlbnwwfHx8fDE3OTM3OTY3MzR8MA&ixlib=rb-4.1.0&q=85&auto=format&fit=crop&w=1800",
    alt: "Chef carving doner kebab from the spit in a takeaway kitchen",
  },
  {
    url: "https://images.unsplash.com/photo-1774028156612-5a2bdb190bfe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxrZWJhYiUyMHJlc3RhdXJhbnQlMjBraXRjaGVuJTIwdGFrZWF3YXklMjBmb29kJTIwY291bnRlcnxlbnwwfHx8fDE3OTM3OTY3Mjd8MA&ixlib=rb-4.1.0&q=85&auto=format&fit=crop&w=1800",
    alt: "Illuminated takeaway shop counter at night",
  },
  {
    url: "https://images.unsplash.com/photo-1572715376701-98568319fd0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHw0fHxyZXN0YXVyYW50JTIwa2l0Y2hlbiUyMGZvb2QlMjBwcmVwYXJhdGlvbiUyMGdyaWxsfGVufDB8fHx8MTc5Mzc5NjczNHww&ixlib=rb-4.1.0&q=85&auto=format&fit=crop&w=1800",
    alt: "Chef preparing a fresh order on the kitchen pass",
  },
  {
    url: "https://images.unsplash.com/photo-1617347454431-f49d7ff5c3b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxmb29kJTIwZGVsaXZlcnklMjBjb3VyaWVyJTIwZHJpdmVyJTIwc2Nvb3RlciUyMHBhY2thZ2V8ZW58MHx8fHwxNzkzNzk2NzM4fDA&ixlib=rb-4.1.0&q=85&auto=format&fit=crop&w=1800",
    alt: "Food delivery rider on a scooter carrying an order at night",
  },
];

export const MARQUEE_ITEMS = [
  "KEBAB SHOPS",
  "FISH & CHIPS",
  "TAKEAWAYS",
  "CAFÉS & BISTROS",
  "RESTAURANTS",
  "0% COMMISSION",
  "LIVE DRIVER GPS",
  "REAL-TIME KITCHEN DASHBOARD",
  "YOUR ONLINE CASHIER",
  "CODING IN STORE",
];

export const FEATURES = [
  {
    id: "online-ordering",
    number: "01",
    title: "Online Ordering System",
    tagline: "Your own branded ordering store — zero commission, all yours.",
    description:
      "Give customers a frictionless checkout on web & mobile: dish modifiers, meal deals, Apple Pay & card payments, instant confirmations. Your brand, your customers, your margin.",
    icon: "ShoppingBag",
    span: "md:col-span-7",
    highlights: ["0% commission on every order", "Modifiers & meal deals built in", "Apple Pay / card checkout"],
  },
  {
    id: "order-management",
    number: "02",
    title: "Order Management Dashboard",
    tagline: "A kitchen display system that keeps up with the Friday rush.",
    description:
      "Live order feed with audio alerts, one-tap status updates, prep timers and thermal receipt printing — counter and kitchen in perfect sync.",
    icon: "LayoutDashboard",
    span: "md:col-span-5",
    highlights: ["Instant audio chime on new orders", "One-tap prep states", "Thermal printer ready"],
  },
  {
    id: "delivery-tracking",
    number: "03",
    title: "Delivery & Driver Tracking",
    tagline: "Dispatch drivers and let customers watch their food arrive.",
    description:
      "Assign orders to your own drivers, optimise routes automatically, and send customers a live tracking map — no more “where's my food?” phone calls.",
    icon: "MapPin",
    span: "md:col-span-5",
    highlights: ["Live customer tracking links", "Automated route optimisation", "Driver payout reports"],
  },
  {
    id: "menu-builder",
    number: "04",
    title: "Menu & Catalogue Builder",
    tagline: "Change a price at the pass — live everywhere in seconds.",
    description:
      "Build categories, modifiers and combo deals visually. Mark items sold-out in two taps and push updates to every customer instantly.",
    icon: "ChefHat",
    span: "md:col-span-7",
    highlights: ["Instant live menu sync", "Combo & meal deal engine", "Sold-out in two taps"],
  },
  {
    id: "analytics-reports",
    number: "05",
    title: "Analytics & Reports",
    tagline: "Know your busiest hour before it happens.",
    description:
      "Revenue breakdowns, peak-hour heatmaps, top dishes and repeat-customer metrics — crisp dark-mode dashboards that turn orders into decisions.",
    icon: "BarChart3",
    span: "md:col-span-12",
    highlights: ["Daily & monthly revenue views", "Peak-hour heatmaps", "Loyalty & re-order metrics"],
  },
];

export const SECTORS = [
  { name: "Kebab Shops", desc: "High-volume doner, shish & wrap combos with multi-sauce selectors.", icon: "Flame" },
  { name: "Fish & Chips", desc: "Counter pickup queues and Friday-night rush optimisation.", icon: "Fish" },
  { name: "Takeaways", desc: "Pizza, burger & Asian takeaway pipelines with driver dispatch.", icon: "UtensilsCrossed" },
  { name: "Cafés & Bakeries", desc: "Pre-orders, breakfast deals and scheduled collection slots.", icon: "Coffee" },
  { name: "Restaurants", desc: "Dine-in QR ordering and takeaway dispatch on one dashboard.", icon: "Store" },
];
